// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nodata_img_div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 30px 0 0 0;
    color: var(--text-muted);
}

.tableau_table {
    border-collapse: collapse;
    min-width: 100%;
    table-layout: fixed;
}

.tableau_body:before {
    content: "@";
    display: block;
    line-height: 8px;
    text-indent: -99999px;
}

.tableau_head {
    width: 100%;
}

.tableau_head_item_th:first-child {
    border-radius: var(--radius-sm) 0 0 var(--radius-sm);
}

.tableau_head_item_th:last-child {
    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

.tableau_head_item_th {
    background-color: var(--bg);
    padding: 12px 12px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.tableau_body tr {
    transition: background-color var(--transition-fast);
    border-bottom: 1px solid var(--border-light);
    background-color: var(--bg-card);
}

.tableau_body tr:nth-child(even) {
    background-color: var(--bg);
}

.tableau_body tr:hover {
    background-color: var(--primary-light);
}

.tableau_body_item {
    padding: 12px 12px;
    font-size: 13px;
    color: var(--text-primary);
}

.tableau_div_flex {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
}

.tableau_pagination {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 6px;
    padding: 16px 0 0 0;
}

.button_nextPage {
    padding: 8px 14px;
    width: max-content;
    font-weight: 600;
    font-size: 13px;
    border-radius: var(--radius-sm);
    background-color: var(--primary);
    color: white;
    transition: all var(--transition-fast);
}

.button_nextPage:hover {
    background-color: var(--primary-hover);
    box-shadow: var(--shadow-sm);
}

.actualPage {
    background-color: var(--primary-light);
    padding: 8px 14px;
    width: max-content;
    font-weight: 600;
    font-size: 13px;
    border-radius: var(--radius-sm);
    color: var(--primary);
    border: 1px solid var(--primary);
}

.pointer {
    cursor: pointer;
}

.tableau_head_item_th, .tableau_body_item {
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tableau_first_line_summup {
    font-weight: 700;
    background-color: var(--primary-light) !important;
}

.tableau_container {
    overflow-x: auto;
    border-radius: var(--radius-md);
}

@media (max-width: 768px) {
    .tableau_table {
        min-width: 600px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/Tableau/tableau.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,mDAAmD;IACnD,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".nodata_img_div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin: 30px 0 0 0;\n    color: var(--text-muted);\n}\n\n.tableau_table {\n    border-collapse: collapse;\n    min-width: 100%;\n    table-layout: fixed;\n}\n\n.tableau_body:before {\n    content: \"@\";\n    display: block;\n    line-height: 8px;\n    text-indent: -99999px;\n}\n\n.tableau_head {\n    width: 100%;\n}\n\n.tableau_head_item_th:first-child {\n    border-radius: var(--radius-sm) 0 0 var(--radius-sm);\n}\n\n.tableau_head_item_th:last-child {\n    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n}\n\n.tableau_head_item_th {\n    background-color: var(--bg);\n    padding: 12px 12px;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.tableau_body tr {\n    transition: background-color var(--transition-fast);\n    border-bottom: 1px solid var(--border-light);\n    background-color: var(--bg-card);\n}\n\n.tableau_body tr:nth-child(even) {\n    background-color: var(--bg);\n}\n\n.tableau_body tr:hover {\n    background-color: var(--primary-light);\n}\n\n.tableau_body_item {\n    padding: 12px 12px;\n    font-size: 13px;\n    color: var(--text-primary);\n}\n\n.tableau_div_flex {\n    display: flex;\n    flex-direction: row;\n    gap: 6px;\n    align-items: center;\n}\n\n.tableau_pagination {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    align-items: center;\n    gap: 6px;\n    padding: 16px 0 0 0;\n}\n\n.button_nextPage {\n    padding: 8px 14px;\n    width: max-content;\n    font-weight: 600;\n    font-size: 13px;\n    border-radius: var(--radius-sm);\n    background-color: var(--primary);\n    color: white;\n    transition: all var(--transition-fast);\n}\n\n.button_nextPage:hover {\n    background-color: var(--primary-hover);\n    box-shadow: var(--shadow-sm);\n}\n\n.actualPage {\n    background-color: var(--primary-light);\n    padding: 8px 14px;\n    width: max-content;\n    font-weight: 600;\n    font-size: 13px;\n    border-radius: var(--radius-sm);\n    color: var(--primary);\n    border: 1px solid var(--primary);\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.tableau_head_item_th, .tableau_body_item {\n    width: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.tableau_first_line_summup {\n    font-weight: 700;\n    background-color: var(--primary-light) !important;\n}\n\n.tableau_container {\n    overflow-x: auto;\n    border-radius: var(--radius-md);\n}\n\n@media (max-width: 768px) {\n    .tableau_table {\n        min-width: 600px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
